import { plainToClass } from "class-transformer";
import _ from "lodash";
import { RequestFormExtended, ApplicationForm, BiospecimenRequest, UserQuery } from '../../scripts/request-form.objects';
import { RequestFormView } from '../../scripts/request-form.view';
import { PickListItem, PickListItemSorted, JsonItem } from '../../../../../shared/entities/pick-list/pick-list.entities';
import { FormatDate } from '../../../../../shared/scripts/date-functions';

export class RequestDashboardTable {
    tableContainerId: string;
    getRoute: string;
    loadingContainerId: string
    loadedContentId: string
    isEditable: boolean;
    isReviewer: boolean;
    tableVarName: string;

    // Table Variables
    id: string = "my-biospecimen-requests";
    referenceId: string = "clear-app";
    requestList: RequestFormExtended[] = [];
    pickLists: JsonItem[] = [];
    sortedPickLists: JsonItem[] = [];
    allPickLists: JsonItem[] = [];
    requestTable: any;
    currentTargetItem: RequestFormExtended;
    visibleApplications: RequestFormExtended[] = [];

    // May move to config
    columns: any[];
    filterTabs: any[]; // Need to add
    loadingFormModal: JQuery<HTMLElement>;
    viewFormModal: JQuery<HTMLElement>;
    viewFormModalTitle: JQuery<HTMLElement>;
    formView: RequestFormView;
    printFormBtn: JQuery<HTMLElement>;

    constructor(config: RequestDashboardTableConfig) {
        this.tableContainerId = config.tableContainerId;
        this.getRoute = config.getRoute;
        this.loadingContainerId = config.loadingContainerId;
        this.loadedContentId = config.loadedContentId;
        this.isEditable = config.isEditable;
        this.isReviewer = config.isReviewer;
        this.tableVarName = config.tableVarName;

        this.viewFormModal = $("#view-form-modal");
        this.viewFormModalTitle = this.viewFormModal.find(".view-form-title");
        this.printFormBtn = this.viewFormModal.find(".view-form-print-btn");
        this.formView = new RequestFormView("view-form-container", "download", this.isReviewer);

        this.loadingFormModal = $("#loading-form-modal");
        this.columns = [
            { data: "ApplicationForm.ProjectShortTitle", title: "Title", className: "text-left font-size12 lh-normal table-column-lg" },
            { data: null, title: "Status", className: "text-left font-size12", render: (data) => { return this.renderApplicationItem(data, "status") } },
            { data: null, title: "Applicant", className: "text-left font-size12 lh-normal table-column-md", render: (data) => { return this.renderApplicationItem(data, "applicant") } },
            { data: null, title: "Investigator(s)", className: "text-left font-size12 lh-normal", render: (data) => { return this.renderApplicationItem(data, "pi") } },
            {
                data: "ApplicationForm.LastUpdated", title: "Last Updated", className: "text-left font-size12", render: (data, type) => {
                    if (!data) return '';  // handle nulls or undefined

                    const dateObj = (data instanceof Date) ? data : new Date(data);

                    if (type === "sort" || type === "type") {
                        return dateObj.valueOf();
                    }
                    return FormatDate(dateObj);
                },
            }
        ];
        this.initialize();
    }

    async initialize(): Promise<any> {
        this.loadingDisplay(true);

        let result: any = await this.getApplications();
        if (result["items"]) {
            this.requestList = plainToClass(RequestFormExtended, <RequestFormExtended[]>result["items"]);
        }
        if (result["pickLists"]) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result["pickLists"]);
        }
        if (result["sortedPickLists"]) {
            this.sortedPickLists = plainToClass(JsonItem, <JsonItem[]>result["sortedPickLists"]);
        }

        this.allPickLists = [...this.pickLists, ...this.sortedPickLists];

        this.createHtmlTemplate();
        this.initializeFilterAndTable();
        this.loadingDisplay(false);
        this.resizeTable();
        this.initializeViewModal();
    }

    private initializeViewModal() {
        // Scroll to top of modal on open
        this.viewFormModal.on('shown.bs.modal', () => {
            let modalBody = this.viewFormModal.find(".scroll-modal-body");
            modalBody.animate({
                scrollTop: 0
            }, 200);
        });

        // trigger print btn
        this.printFormBtn.on('click', () => {
            this.formView.triggerPrint();
        })
    }

    createHtmlTemplate(): void {
        // Create Content Blocks
        let content = `
            <div class="list-table-container">
                <div class="biorep-datatable border-bottom edit-table-container" id="${this.referenceId}-table-container">
                    
                </div>
            </div>
            <div id="${this.referenceId}-detail-menu-container">

            </div>
        `
        $(`#${this.tableContainerId}`).empty().html(content);
        //this.generateFilterTabContent();
    }

    async getApplications() {
        let result: any;
        try {
            result = await $.ajax(this.getRoute, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    loadingDisplay(isLoading: boolean): void {
        if (isLoading) {
            $(`#${this.loadedContentId}`).addClass("d-none");
            $(`#${this.loadingContainerId}`).removeClass("d-none");
        }
        else {
            $(`#${this.loadedContentId}`).removeClass("d-none");
            $(`#${this.loadingContainerId}`).addClass("d-none");
        }
    }

    initializeFilterAndTable() {
        // Filter Tabs
        //this.generateFilterTabContent();

        // Select Table
        $(`#${this.referenceId}-table-container`).empty().html(
            `<table id="${this.referenceId}-select-table" class="table table-striped selectable-rows w-100" style="width:100%"></table>`
        )

        // Clear Detail Menu Container
        $(`#${this.referenceId}-detail-menu-container`).empty();

        // Create Table
        this.initializeTable();
    }

    renderPickListItem(data: any, pickListName: string, isMultiple: boolean = false, isSorted: boolean = false, separator: string = ", "): string {
        if (!data) {
            return "";
        }

        let sortedPickList: PickListItemSorted[] = [];
        let pickList: PickListItem[] = [];

        if (isSorted) {
            let foundList: PickListItemSorted[] = this.sortedPickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                sortedPickList = foundList;
            }
        }
        else {
            let foundList: PickListItem[] = this.pickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                pickList = foundList;
            }
        }

        if (sortedPickList.length == 0 && pickList.length == 0) {
            return "";
        }

        let returnStrArray: string[] = [];
        let returnStr: string = "";
        if (isMultiple) {
            let stringArrIds: string[] = data.split("|");
            stringArrIds = _.uniq(stringArrIds);

            for (let i = 0; i < stringArrIds.length; i++) {
                let numId: number = parseInt(stringArrIds[i]);
                if (numId) {
                    let foundItem = null;
                    if (isSorted) {
                        foundItem = sortedPickList.find(item => item.Id == numId);
                    }
                    else {
                        foundItem = pickList.find(item => item.Id == numId);
                    }

                    if (foundItem) {
                        returnStrArray.push(foundItem.Value);
                    }
                }
            }

            returnStrArray.sort();
            returnStr = returnStrArray.join(separator);
        }
        else {
            let foundItem = null;
            if (isSorted) {
                foundItem = sortedPickList.find(item => item.Id == data);
            }
            else {
                foundItem = pickList.find(item => item.Id == data);
            }

            if (foundItem) {
                returnStr = foundItem.Value;
            }
        }
        return returnStr;
    }

    renderApplicationItem(data: RequestFormExtended, type: string): string {
        if (type == "applicant") {
            let returnContent = "";
            let firstName = data.ApplicationForm.RequestorFirstName;
            let lastName = data.ApplicationForm.RequestorLastName;
            let email = data.ApplicationForm.RequestorEmail;
            if (firstName && lastName && email) {
                returnContent = `${firstName} ${lastName} (${email})`;
            }
            return returnContent;
        }
        else if (type == "pi") {
            let piNames = data.ApplicationForm.PINames;
            let returnContent = "";
            if (piNames) {
                let piList: string[] = piNames.split("|");
                for (let i = 0; i < piList.length; i++) {
                    if (i > 0) { returnContent += "<br>" }
                    let name = piList[i];
                    returnContent += name;
                }
            }
            return returnContent;
        }
        else if (type == "status") {
            let returnContent = "";
            let statusList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-application-status").Json;
            if (statusList) {
                let statusId = data.ApplicationForm.RequestStatusId;
                let foundStatus = statusList.find(item => item.Id == statusId);

                // Not Started
                if (statusId == 1) {
                    return `<i class="fa-regular fa-circle fa-lg pr-2"></i>${foundStatus.Value}`;
                }
                // In Draft
                else if (statusId == 2) {
                    return `<i class="fa-solid fa-circle-half-stroke fa-lg pr-2"></i>${foundStatus.Value}`;
                }
                // Submitted
                else if (statusId == 3) {
                    return `<i class="fa-solid fa-circle-check fa-lg pr-2"></i>${foundStatus.Value}`;
                }
                // Deleted
                else if (statusId == 4) {
                    return `<i class="fa-solid fa-trash-can fa-lg pr-2"></i>${foundStatus.Value}`;
                }

                return returnContent;
            }
        }
        return "";
    }

    initializeTable(): void {
        let columns = _.cloneDeep(this.columns);

        let tableColumns: any[] = [];
        let firstColumn = columns.shift();
        if (firstColumn) {
            tableColumns.push(firstColumn);
            tableColumns.push(
                { data: "ApplicationForm.Id", title: "", width: "26px", orderable: false, className: "text-center detail-btn-container", render: (data) => this.renderDetailButton(data) }
            )
        }
        tableColumns.push(...columns);

        let fixedColCount = 2;
        if (this.isEditable) fixedColCount = 2;

        let sortCol = this.columns.length;
        this.requestTable = $(`#${this.referenceId}-select-table`).DataTable({
            //"dom": `<"${this.id}-top-controls"<"${this.id}-search-bar"f><"${this.id}-count-found"B>>rtip`,
            "dom": `<"${this.id}-top-controls d-flex align-items-center justify-content-between mb-2"
                <"left-controls"f>
                <"right-controls d-flex align-items-center"<"#${this.referenceId}-table-count-found.font-italic"><"dt-buttons ml-3">B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: fixedColCount
            },
            language:
            {
                search: "Search",
                emptyTable: "No existing requests."
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "biospecimen-requests",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8'
                }
            ],
            data: this.requestList,
            order: [[sortCol, 'desc']],
            initComplete: (settings, json) => {

            },
        });

        this.requestTable.on('search.dt draw.dt', () => {
            const visibleCount = this.requestTable.rows({ filter: 'applied' }).count();
            this.updateCount(visibleCount);
        });

        //$(`.${this.id}-top-controls`).addClass('row mx-0 align-items-center');

        //$(`.${this.id}-search-bar`).addClass('col-12 col-md-3 px-0');
        //$(`.${this.id}-count-found`).addClass('col-12 col-md-9 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        //$(`.${this.id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        //this.tableController = new TableColumnVisibilityControllerV2(`#${this.referenceId}-select-table`, `#${this.id}-column-select`, this.tableColumnGroups, `${this.id}-table-column-visibility`);

        this.updateCount(this.requestList.length);
        this.visibleApplications = this.requestList;
    }

    updateCount(numItems: number): void {
        let content = "";
        if (numItems == 1) {
            content = "1 Request Found"
        }
        else {
            content = `${numItems.toString()} Requests Found`
        }

        $(`#${this.referenceId}-table-count-found`).text(content);
    }

    renderDetailButton(data: any): string {
        let content = `
            <div class="btn-group dropright">
                <button type="button" class="btn p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onclick="page.${this.tableVarName}.updateMenuPosition(event)">
                    <div class="item-detail-button" data-id="${data}"><div><i class="fa-solid fa-ellipsis"></i></div></div>
                </button>
                <div class="dropdown-menu biorep-dropdown-menu">
                    
                </div>
            </div>
        `
        return content;
    }

    updateMenuPosition(e: Event) {
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);
        let table = $(targetElement).closest("table");
        this.setTargetedRow(targetElement);

        $(`#${this.referenceId}-detail-menu-container`).empty();

        let dropdownMenu = targetElement.siblings('.biorep-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        if (dropdownMenu.length <= 0) {
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu biorep-dropdown-menu">
                    ${this.getMenuContent()}
                </div>
            `)
            targetElement.dropdown();
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.biorep-dropdown-menu');
                $(`#${this.referenceId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            dropdownMenu.html(`
                ${this.getMenuContent()}
            `)
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".biorep-dropdown-menu");
                $(`#${this.referenceId}-detail-menu-container`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

    setTargetedRow(target: JQuery<HTMLElement>): void {
        let tr = $(target).closest('tr');
        let row = this.requestTable.row(tr);
        this.currentTargetItem = <RequestFormExtended>row.data();            
    }

    getMenuContent(): string {
        let menuOptions = "";

        menuOptions += `<a href="#" class="dropdown-item" onclick="page.${this.tableVarName}.viewApplication('${this.currentTargetItem.ApplicationForm.Id}')"><i class="fa-solid fa-magnifying-glass dropdown-icon pr-2"></i> View Request</a>`
        // Not Started or In Draft
        if (this.currentTargetItem.ApplicationForm.RequestStatusId < 3 && this.isEditable) {
            menuOptions += `<a href="#" class="dropdown-item" onclick="page.${this.tableVarName}.editApplication('${this.currentTargetItem.ApplicationForm.Id}')"><i class="fa-solid fa-pen-to-square dropdown-icon pr-2"></i> Edit Request</a>`
        }
        // Create menu options
        return menuOptions;
    }

    resizeTable(): void {
        if (this.requestTable) {
            this.requestTable.columns.adjust().draw();
        }
    }

    updateTable(items: any[]) {
        // Removes any shown menus
        $("#detail-menu-container").empty();

        this.requestTable.clear();
        this.requestTable.rows.add(items).draw();
        this.updateCount(items.length);
        this.resizeTable();
        this.visibleApplications = items;
    }

    editApplication(appId: string): void {
        let origin = window.location.origin
        let targetUrl = `${origin}/secure/biospecimens/sample-request-form/request-form/${appId}`

        window.location.href = targetUrl;

        setTimeout(() => {
            this.loadingFormModal.modal('show');
        }, 500);
    }

    viewApplication(appId: string): void {
        let foundForm = this.requestList.find(form => form.ApplicationForm.Id.toString() == appId);
        if (foundForm) {
            let institutionTypePickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-institution-type").Json;
            let supportPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-biostatistician-support").Json;
            let yesNoPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-yes-no")?.Json; 
            let fundingStatusPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-funding-status")?.Json;
            let requestTypePickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-new-resubmitted-request")?.Json;
            let queryList: UserQuery[] = this.pickLists.find(list => list.Id == "user-queries").Json;

            this.formView.initialize(foundForm, institutionTypePickList, supportPickList, yesNoPickList, fundingStatusPickList, requestTypePickList, queryList);
            let title = "RECOVER Application";
            if (foundForm.ApplicationForm.ProjectShortTitle) {
                title = foundForm.ApplicationForm.ProjectShortTitle;
            }
            this.viewFormModalTitle.text(title);
            this.viewFormModal.modal('show');
        }
    }
}

export class RequestDashboardTableConfig {
    tableContainerId: string; // Where the table and filters will be placed on the page
    getRoute: string; // Route used for GET request for applications
    loadingContainerId: string // Id of the container showing loading indicator - show while loading
    loadedContentId: string // Id of the loaded content container - show after loading
    isEditable: boolean; // Allow items to be edited
    isReviewer: boolean; // Changes Queries to allow for others to view
    tableVarName: string; // name of the variable that is storing the ApplicationTable item
}